import Icon from '@mui/material/Icon'

export default function DatumLoader() {
    return <Icon>loop</Icon>
}
